// extracted by mini-css-extract-plugin
export default {"wrapper":"PeriodSelector_wrapper__SGDDr","btn":"PeriodSelector_btn__Ufyna","active":"PeriodSelector_active__H4YJA"};